import * as ng from 'angular';
import { ITimestamps } from '../../../commons/interfaces/timestamps';
import { ArchiSmallServices } from '../../../services/archismall.service';

class AdminController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'ArchiSmallServices'
    ];
    constructor(
        private $scope: {
          marcheTemporali: number,
          [key: string]: any
        },
        private $rootScope: any,
        private ArchiSmallServices: ArchiSmallServices,
    ) {
        $scope.pageHeader = 'Admin';
        $scope.marcheTemporali = 0;

        $scope.getTimestamps = () => {
          ArchiSmallServices.getLastTimestamps()
            .then((response) => {
              $scope.marcheTemporali = (JSON.parse(JSON.stringify(response)) as ITimestamps).number;
            }, (error) => {
              $rootScope.alert('error', error);
            });
        };
        $scope.getTimestamps();
    }
}

export const AdminComponent: ng.IComponentOptions = {
    template: require('./admin.html'),
    controller: AdminController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/admin.ts